import React from 'react';
import { Avatar } from "../../widgets";
import { Dropdown } from "react-bootstrap";
import {  WORK_TYPE_COLOURS } from '../../../constants/index';

const MultipleSelection = ({ options, selected, className, onSelect, onToggle}) => {
    const ifDisabled = id => (id === selected);
    const ifSelected = id => (id === selected);

    return <div className={className || ""}>
        {options.map((item) => {
            if (item.list && item.list.length > 0) {
                const isSelectedDropDown = (item.list.filter(e => selected === e.work_type_id).length > 0);

                return <Dropdown
                    key={item.work_type_id}
                    alignRight={true}
                    onToggle={onToggle}
                    onSelect={eventKey => onSelect(parseInt(eventKey))}>
                    <Dropdown.Toggle as="div">
                        <Avatar
                            name={item.work_type.split(" ")[0]}
                            autoTitle="false"
                            color={WORK_TYPE_COLOURS[10]}
                            singleLetterAvatar={true}
                            className={`img-avatar avatar-dropdown mb-1 ${isSelectedDropDown ? "selected" : ""}`}
                        />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {item.list.map(item =>
                            <Dropdown.Item
                                as={AvatarItem}
                                key={item.work_type_id}
                                active={ifSelected(item.work_type_id)}
                                disabled={ifDisabled(item.work_type_id)}
                                eventKey={item.work_type_id}>
                                {item.work_type}
                            </Dropdown.Item>)}
                    </Dropdown.Menu>
                </Dropdown >
            }
            else {
                return <Avatar
                    key={item.work_type_id}
                    className={`img-avatar ${selected === item.work_type_id && "selected"} ${ifDisabled(item.work_type_id) && "disabled"}`}
                    name={item.work_type.split(" ")[0]}
                    color={WORK_TYPE_COLOURS[item.work_type_id]}
                    singleLetterAvatar={true}
                    {...!ifDisabled(item.work_type_id) && {
                        onClick: () => onSelect(item.work_type_id)
                    }}
                />
            }
        })}
    </div>;
}

const AvatarItem = React.forwardRef(
    ({ children, onClick, disabled, className }, _) => {
        const selected = className ? className.includes("active") : false;
        return <div
            className={`dropdown-item-custom ${disabled && "disabled"}`}>
            <label className="d-flex">
                <div style={{ width: "13px" }}>
                    {selected && <i className="fa fa-check" aria-hidden="true" />}
                </div>
                <span
                    className={`item-text ${selected && "checked"}`}
                    onClick={onClick}>
                    {children}
                </span>
            </label>
        </div>;
    },
);

export default MultipleSelection;